var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_4285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1511 15.017C21.8209 15.017 21.5533 15.2846 21.5533 15.6148V20.9219C21.5521 21.9118 20.7501 22.7141 19.7602 22.7151H2.98862C1.99861 22.7141 1.19664 21.9118 1.19545 20.9219V5.3458C1.19664 4.35603 1.99867 3.55382 2.98862 3.55263H8.29581C8.62594 3.55263 8.89354 3.28503 8.89354 2.9549C8.89354 2.62496 8.62594 2.35718 8.29581 2.35718H2.98862C1.33878 2.35903 0.00185294 3.69596 0 5.3458V20.9221C0.00185294 22.5719 1.33878 23.9088 2.98862 23.9108H19.7602C21.4099 23.9088 22.7469 22.5719 22.7488 20.9221V15.6148C22.7488 15.2846 22.4812 15.017 22.1511 15.017Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5121 0.81908C21.4616 -0.23136 19.7585 -0.23136 18.7082 0.81908L8.04427 11.4829C7.97128 11.5559 7.91844 11.6465 7.8909 11.746L6.48858 16.8087C6.46028 16.9107 6.45954 17.0183 6.48645 17.1206C6.51336 17.2229 6.56695 17.3162 6.64175 17.3911C6.71654 17.4659 6.80985 17.5195 6.91215 17.5464C7.01445 17.5734 7.12208 17.5727 7.22402 17.5444L12.2867 16.1419C12.3862 16.1143 12.4769 16.0615 12.5499 15.9885L23.2134 5.32449C24.2622 4.27327 24.2622 2.57167 23.2134 1.52051L22.5121 0.81908ZM9.34666 11.8714L18.0742 3.14369L20.8889 5.95837L12.1612 14.6861L9.34666 11.8714ZM8.78444 12.9996L11.0331 15.2486L7.92264 16.1104L8.78444 12.9996ZM22.3683 4.47924L21.7343 5.11307L18.9194 2.29815L19.5536 1.66426C20.1371 1.08076 21.0831 1.08076 21.6666 1.66426L22.3683 2.36563C22.9508 2.94985 22.9508 3.89527 22.3683 4.47924Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_4285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e457eff4efa0c8db78d32e4f1c39d76c.svg";
export { ForwardRef as ReactComponent };